module.exports = __webpack_public_path__ + "img/Fete_des_meres.f7c5a79.jpg";